import { createLogger } from '@svenskaspelab/nova-core/log';
import { useContext, useMemo } from 'react';
import { getCouponId } from '../../../../../schema/coupon/entry.js';
import { getDrawNumber } from '../../../../../schema/draw/entry.js';
import { useCurrentDrawInfo } from '../../draw/hooks/useCurrentDrawInfo.js';
import { CouponIdContext } from '../components/CouponIdContext.js';
import { useCouponIndex } from './useCouponIndex.js';
const logger = createLogger('poolbetting.couponid-hook');
/**
 * Returns the active coupon id based on the current draw number and coupon type.
 * Should be used under a CouponIdProvider. If not, it will default to "standard" coupon type.
 *
 * @returns Current coupon id based on the context of the application
 * @throws {Error} if hook is used outside of a CouponIdProvider
 */
export function useCouponId() {
  const couponTypeContext = useContext(CouponIdContext);
  const drawContext = useCurrentDrawInfo();
  const {
    product
  } = drawContext;
  let {
    drawNumber
  } = drawContext;
  const couponIndex = useCouponIndex();
  if (!couponTypeContext) {
    throw new Error('useCouponId must be used within a CouponIdProvider');
  }
  const couponType = couponTypeContext.getType();
  if (!couponType) {
    throw new Error('couponType not set with CouponType component');
  }
  if (!drawNumber) {
    // In case there is no draw number (no opened draws) we  default to 0 instead of returning null or undefined.
    // This is due to avoid the complexity for all other hooks and functions to handle it.
    logger.debug('No opened draws available, defaulting drawNumber to 0', {
      product: product.type,
      couponType
    });
    drawNumber = getDrawNumber(0);
  }
  return useMemo(() => [getCouponId(product.type, drawNumber, couponType), couponIndex], [product.type, drawNumber, couponType, couponIndex]);
}